import { Avatar, Badge, Button, Skeleton, tableHelpers, Tooltip } from '@round/creatorbase-ui';
import { isRecentlyAddedCreator } from '../../../../utils/creatorSearchUtils';
import { getMeta, CellContext, getCreatorName, getCreatorDetailsAccount } from '../../helpers';
import styles from './CreatorCell.module.css';
import { lucideIcons } from '@round/creatorbase-ui';

const { Mail, ChartSpline: DiagramIcon } = lucideIcons;

export const CreatorCell = ({ row: { original }, table }: CellContext) => {
    const { isLoading, getCreatorImages, getAreCreatorImagesLoading, onOpenCreatorDetails } = getMeta(table);

    const isBaseLoading = tableHelpers.isLoadingRow(original) || isLoading;

    const imageUrls = getCreatorImages(original);
    const imageSrc = imageUrls.tiktok || imageUrls.instagram;

    return (
        <div className={styles.container}>
            <Avatar className={styles.avatar} size="lg">
                {isBaseLoading || getAreCreatorImagesLoading(original) ? (
                    <Skeleton className={styles.avatarSkeleton} />
                ) : (
                    <>
                        <Avatar.Image src={imageSrc ?? undefined} />
                        <Avatar.Fallback>{getCreatorName(original).charAt(0).toUpperCase()}</Avatar.Fallback>
                    </>
                )}
            </Avatar>

            <div className={styles.infoContainer}>
                {isBaseLoading ? (
                    <Skeleton className={styles.name} />
                ) : (
                    <div className={styles.nameRow}>
                        <p className={styles.name}>{getCreatorName(original)}</p>
                        {isRecentlyAddedCreator(original.first_seen) && <Badge className={styles.newBadge}>New</Badge>}
                    </div>
                )}
                <div className={styles.contactDetailsRow}>
                    {isBaseLoading ? (
                        <Skeleton className={styles.contactDetails} />
                    ) : (
                        <>
                            <Mail className={styles.mailIcon} aria-hidden />
                            <span className={styles.contactDetails}>{original.primary_contact_details || '-'}</span>
                        </>
                    )}
                </div>
            </div>

            {/* The modal opens on one of the creator's accounts, so a creator with none has nothing to open. */}
            {!isBaseLoading && onOpenCreatorDetails && getCreatorDetailsAccount(original) && (
                <Tooltip delayDuration={300}>
                    <Tooltip.Trigger asChild>
                        <Button
                            className={styles.detailsButton}
                            variant="ghost"
                            size="icon-sm"
                            aria-label={`View ${getCreatorName(original)} details`}
                            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                                e.stopPropagation();
                                onOpenCreatorDetails(original);
                            }}
                        >
                            <DiagramIcon />
                        </Button>
                    </Tooltip.Trigger>
                    <Tooltip.Content>Creator details</Tooltip.Content>
                </Tooltip>
            )}
        </div>
    );
};
